/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FaxDocument } from './FaxDocument';
import {
    FaxDocumentFromJSON,
    FaxDocumentFromJSONTyped,
    FaxDocumentToJSON,
} from './FaxDocument';

/**
 * 
 * @export
 * @interface FaxesFindAllResponse
 */
export interface FaxesFindAllResponse {
    /**
     * 
     * @type {Array<FaxDocument>}
     * @memberof FaxesFindAllResponse
     */
    data: Array<FaxDocument>;
    /**
     * Total number of fax documents available across all pages
     * @type {number}
     * @memberof FaxesFindAllResponse
     */
    total: number;
    /**
     * Which page the repsonse represents
     * @type {number}
     * @memberof FaxesFindAllResponse
     */
    page: number;
    /**
     * Maximum number of faxes per page
     * @type {number}
     * @memberof FaxesFindAllResponse
     */
    limit: number;
    /**
     * Whether or not there is a next page
     * @type {boolean}
     * @memberof FaxesFindAllResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FaxesFindAllResponse interface.
 */
export function instanceOfFaxesFindAllResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FaxesFindAllResponseFromJSON(json: any): FaxesFindAllResponse {
    return FaxesFindAllResponseFromJSONTyped(json, false);
}

export function FaxesFindAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxesFindAllResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FaxDocumentFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FaxesFindAllResponseToJSON(value?: FaxesFindAllResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(FaxDocumentToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

